import { createContext } from "react";

export const DynamicThemeContext = createContext({
    hasDynamicTheme: false,
    dynamicThemeEnabled: true,
    setDynamicThemeEnabled: () =>
        console.error(
            "DynamicThemeContext provider not implemented or values not supplied"
        ),
});
